module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qre",
    class: 'qre--' + _vm.tom,
    attrs: {
      "role": "status"
    }
  }, [_c('p', {
    staticClass: "qre-titulo"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.icone,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    " + _vm._s(_vm.titulo) + "\n  ")]), _vm._v(" "), (_vm.situacao === 'erro') ? _c('p', {
    staticClass: "qre-texto"
  }, [_vm._v("Confira as ocorrências da entidade no Sapiens antes de responder a regularidade.")]) : _vm._e(), _vm._v(" "), (_vm.situacao === 'concluida' && _vm.total > 0) ? _c('ul', {
    staticClass: "qre-lista"
  }, [_vm._l((_vm.entidade), function(ocorrencia, i) {
    return _c('li', {
      key: 'e' + i
    }, [_c('span', {
      staticClass: "qre-origem"
    }, [_vm._v("Entidade")]), _vm._v("\n      " + _vm._s(ocorrencia.codoco) + " - " + _vm._s(ocorrencia.desroc) + "\n      "), (ocorrencia.datger) ? _c('span', {
      staticClass: "qre-data"
    }, [_vm._v("desde " + _vm._s(_vm._f("moment")(ocorrencia.datger, 'L')))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.projetos), function(ocorrencia, i) {
    return _c('li', {
      key: 'p' + i
    }, [_c('span', {
      staticClass: "qre-origem"
    }, [_vm._v("Projeto " + _vm._s(ocorrencia.numprj))]), _vm._v("\n      " + _vm._s(ocorrencia.codoco) + " - " + _vm._s(ocorrencia.desroc) + "\n      "), (ocorrencia.datger) ? _c('span', {
      staticClass: "qre-data"
    }, [_vm._v("desde " + _vm._s(_vm._f("moment")(ocorrencia.datger, 'L')))]) : _vm._e()])
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66b54c5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/quadroRestricoesEntidade.vue
// module id = 1993
// module chunks = 1